export enum LibraryEvent {
  'DELETE_AUDIO' = 'DELETE_AUDIO',
}
